import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo(0, 0); 
    }, 150);

    return () => clearTimeout(timer); 
  }, [location]);

  return null;
};

export default ScrollToTop;
